import { HttpException } from '../http/exceptions';

/**
 * The status-and-cause tail of a `[sycai] …` error line: `(status 404)`, or
 * `(status 0): Network Error`.
 *
 * `status ?? 0` folds every "no real HTTP status" error into one bucket:
 * HttpException(0, …) from axios (DNS failure, ECONNREFUSED, timeout/abort, a
 * CORS-blocked response) AND a bare Error with no `.status` field at all — our own
 * fatal(), e.g. a config/roots misuse, or buildUrl's empty-baseUrl guard. Both halves of
 * that bucket are generated LOCALLY, never by a server, so the message is safe to print
 * in full. A real HTTP status (>0) means the message may echo a server-controlled
 * response body, so only the status is printed there. Neither branch can reach an
 * account, a token or a cookie (§6.1).
 *
 * One copy, because there were two: index.tsx's session diagnostic and
 * DiagnosisService.report carried these six lines verbatim, comment included.
 */
export function describeError(error: unknown): string {
  const status = error instanceof HttpException ? error.status : 0;

  if (status !== 0) {
    return `(status ${status})`;
  }

  return `(status 0): ${error instanceof Error ? error.message : 'unknown cause'}`;
}
